import { render, staticRenderFns } from "./NormalMale.vue?vue&type=template&id=00a1767e&scoped=true&"
import script from "./NormalMale.vue?vue&type=script&lang=js&"
export * from "./NormalMale.vue?vue&type=script&lang=js&"
import style0 from "./NormalMale.vue?vue&type=style&index=0&id=00a1767e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1767e",
  null
  
)

export default component.exports